var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsByClicks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 10.4999C5.83325 5.98959 9.48959 2.33325 13.9999 2.33325C18.5102 2.33325 22.1666 5.98959 22.1666 10.4999V17.4999C22.1666 22.0102 18.5102 25.6666 13.9999 25.6666C9.48959 25.6666 5.83325 22.0102 5.83325 17.4999V10.4999Z",
    stroke: "#939CB4",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14 6L14 12",
    stroke: "#939CB4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsByClicks);
export default __webpack_public_path__ + "static/media/statisticsByClicks.24421a8b2dee5f9cf484fcb89fe741e1.svg";
export { ForwardRef as ReactComponent };